<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Bidang Musrembang</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 30%">Kode Bidang</th>
                            <th style="width: 30%">Nama Bidang</th>
                            <th style="width: 20%">Uraian Bidang</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data,index) in list_bidmus" :key="data.bidang_musrenbang_id">
                              <td>{{index+1}}</td>
                              <td>{{data.kode_bid}}</td>
                              <td>{{data.nama_bidang}}</td>
                              <td>{{data.uraian}}</td>
                              <td class="text-center" >
                                
                       
                            <button @click="selectDataLink(data.bidang_musrenbang_id)" class="btn bg-light-blue btn-xs waves-effect" title="Bidang Urusan Satuan Kerja" id="edit_data" data-toggle="modal" data-target="#m_add_link">
                                <i class="material-icons" >link</i>
                            </button>
                            &nbsp;
                                <button @click="selectData(data.kode_bid, data.nama_bidang, data.uraian ,data.bidang_musrenbang_id)"  class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.bidang_musrenbang_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button  type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                

                <!-- ============================================================ MODAL ======================================================================== -->





                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">
                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.kode" type="text" class="form-control" placeholder="Ex : 01">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.nama" type="text" class="form-control" placeholder="Ex : Pelayanan Umum">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Uraian Bidang </label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <textarea v-model="data.uraian" rows="4" class="form-control no-resize" placeholder="Please type what you want..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Bidang xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_bidang" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-indigo">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row ">
                                        <div class="col-md-12 text-right">
                                            <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data_satker"><i class="material-icons">add</i></button> 
                                            <br>
                                        </div>
                                    </div>


                                <div class="row clearfix">
                                <br>
                                <div class="table-responsive">
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 30%">Kode Bidang</th>
                                            <th style="width: 30%">Nama Bidang</th>
                                
                                            <th style="width: 10%">#</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="h_isitable" >
                                            <td>1.</td>
                                            <td>01</td>
                                            <td>Urusan Wajib Pelayanan Dasar Pendidikan</td>
                                        
                                            <td class="text-center" >
                                                
                                                <button class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>


                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                </div>


                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">

                                 <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="kode" type="text" class="form-control" placeholder="Ex : 01">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Bidang</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="nama" type="text" class="form-control" placeholder="Ex : Pelayanan Umum">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Uraian Bidang </label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <textarea v-model="uraian" rows="4" class="form-control no-resize" placeholder="Please type what you want..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">Simpan</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">Kembali</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
               
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_link" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                    
                                    <h4 class="modal-title" id="largeModalLabel">Tambahkan Satuan Kerja</h4>
                                </div>
                                
                                <div class="modal-body">
                                    <button @click="trigger()" type="submit" data-dismiss="modal" data-toggle="modal" data-target="#m_pilih_skpd" class="btn btn-info waves-effect "> <i class="material-icons" >add</i></button>
                                    <br>
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 15%">Kode Satuan Kerja</th>
                                            <th style="width: 30%">Nama Satuan Kerja</th>
                                            <th style="width: 20%">Pilihan</th>
                                        </tr>

                                        </thead>
                                        <tbody>
                                            <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                            <tr class="h_isitable" v-for="(data, index) in list_bidang_relate" :key="data.bidang_urusan_pemerintahan_id">
                                                <td>{{index+1}}</td>
                                                <td>{{data.kode_bidang}}</td>
                                                <td>{{data.nama_bidang}}</td>
                                                <td> 
                                                    <button type="submit" @click="removeDataRelate(data.bidang_urusan_pemerintahan_id)" class="btn btn-danger waves-effect "> <i class="material-icons">delete</i> </button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-warning waves-effect" data-dismiss="modal">TUTUP</button>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
               
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Bidang Urusan Satuan Kerja  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_pilih_skpd" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                    
                                    <h4 class="modal-title" id="largeModalLabel">Tambahkan Satuan Kerja</h4>
                                </div>

                                <form @submit.prevent="addDataBid()">
                                <div class="modal-body">
                                                    
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 15%">Kode Satuan Kerja</th>
                                            <th style="width: 30%">Nama Satuan Kerja</th>
                                            <th style="width: 10%">Pilih</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                            <tr class="h_isitable" v-for="(data, index) in list_bidang" :key="data.bidang_urusan_pemerintahan_id">
                                                <td>{{index+1}}</td>
                                                <td>{{data.kode_bidang}}</td>
                                                <td>{{data.nama_bidang}}</td>
                                                <td>
                                                    <!-- <input type="hidden" v-model="dataSKPD.bidang_id" > -->
                                                    <div class="demo-checkbox">
                                                        <input type="checkbox" @click="addtoArray(data.bidang_urusan_pemerintahan_id)" v-bind:id="data.bidang_urusan_pemerintahan_id"/>
                                                        <label v-bind:for="data.bidang_urusan_pemerintahan_id"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit"  class="btn btn-info waves-effect ">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal" data-toggle="modal" data-target="#m_add_link" >KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_bidang_musrembang/';
    const ADD_URL_BID = URL_APP+'api/v1/planning_bidang/';


    export default {
    name: "monev_kabupaten",
    data() {
        return {
            data:{
                kode: '',
                nama: '',
                uraian: '',
            },
            dataBid:{
                _id: '',
                _id_array: '',
            },
            kode: '',
            nama: '',
            uraian: '',
            _id: '',
            list_bidmus: [],
            list_bidang: [],
            list_bidang_relate: [],
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        addtoArray: function(a){
                let cb = document.getElementById(a).checked  
                if (cb == true){
                    this.dataBid._id_array.push(a);
                } else {
                    this.dataBid._id_array.pop(a);
                }
                console.log(JSON.stringify(this.dataBid));
        },
        addDataBid: function(){
                console.log(JSON.stringify(this.dataBid));
                fetch(ADD_URL_BID+'addDataBidMus', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.dataBid)
                }).then(res => res.json()).then((data_bidang) => {
                    // console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataBidang();
                    this.getDataBidRelate();
                });
            },
        getDataBidRelate: function(){
            console.log(this.dataBid._id);
            fetch(ADD_URL_BID+'readDataBidHaveBidMus', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    _id : this.dataBid._id,  
                })
            }).then((res) => res.json()).then((data_urusan) => {
                this.list_bidang_relate = data_urusan.data;
            })
        },
        addData: function(){
            fetch(ADD_URL+'createData', {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara "+ localStorage.token
                },
                body: JSON.stringify(this.data)
            }).then(res => res.json()).then((data_urusan) => {
                this.alertku('success', 'Berhasil Menambah Data!');
                this.getData();
            });
        },
        getDataBidang: function(){
            fetch(ADD_URL_BID+'readDataNoBidMus', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    data_ke : this.page_first,
                    cari_value : this.cari_value
                })
            }).then((res) => res.json()).then((data_urusan) => {
                this.list_bidang = data_urusan.data;
            })
        },
        selectDataLink : function(a){
              this.dataBid._id = a;
              this.getDataBidRelate();
        },
        trigger : function(){
            this.getDataBidang();
            this.dataBid._id_array = [] ;
        },
        editData: function(){
            fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kode : this.kode,
                        nama : this.nama,
                        uraian : this.uraian,
                        _id : this._id,
                    })
            }).then((res_data) => {
                this.alertku("success", "Berhasil Mengubah Data!");
                this.getData();
            });      
        },
        getData: function(){
            fetch(ADD_URL+'readData', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    data_ke : this.page_first,
                    cari_value : this.cari_value
                })
            }).then((res) => res.json()).then((data_urusan) => {
                this.list_bidmus = data_urusan.data;
                this.page_last = data_urusan.jml_data;
            })
        },
        selectData : function(a, b, c, d){
            this.kode = a;
            this.nama = b;
            this.uraian = c;
            this._id = d;
        },
        alertku : function(type, title){
            this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
            });
        },
        removeData: function(id){
            this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if(result.value) {
                fetch(ADD_URL+"deleteData", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify({
                        id : id,
                    })
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
                this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
            })
        },
        removeDataRelate : function(id){
            this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if(result.value) {
                fetch(ADD_URL_BID+"deleteDataRelateBid", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify({
                        id : id,
                    })
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getDataBidRelate();
                });
                this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
            })
        },

    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        this.getData();
        localStorage.sidemenu = 'planing';
    },
    };
</script>
